import { osVersion, osName, fullBrowserVersion, browserName, deviceType } from 'react-device-detect';

// ----------------------------------------------------------------------

export default function userAgent() {
  const deviceName = deviceType && deviceType === 'browser' ? 'PC' : deviceType;

  const device = deviceName ? deviceName.slice(0, 20) : null;
  const os = osName ? `${osName} ${osVersion}`.slice(0, 50) : null;
  const browser = browserName ? `${browserName} ${fullBrowserVersion}`.slice(0, 50) : null;

  return { device, os, browser };
}